import { useCallback } from "react"
import { graphql, UseMutationConfig } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS } from "@/modules/patients/detail/conclude/services/telematikInfrastructureSigningMutationParams"
import {
  De_signReferralLetterDocumentWithTelematikInfrastructureInput,
  useDeSignReferralLetterWithTelematikInfrastructureMutation as useDeSignReferralLetterWithTelematikInfrastructureMutationType,
} from "@/modules/patients/detail/referral/de/services/__generated__/useDeSignReferralLetterWithTelematikInfrastructureMutation.graphql"

const mutation = graphql`
  mutation useDeSignReferralLetterWithTelematikInfrastructureMutation(
    $input: De_signReferralLetterDocumentWithTelematikInfrastructureInput!
  ) {
    de_signReferralLetterDocumentWithTelematikInfrastructure(input: $input) {
      de_ReferralLetter {
        id
        progressNoteId
        fileId
        signedAt
        signedBy
        updatedAt
        updatedBy
      }
      errors {
        __typename
        ... on Error {
          message
        }
        ... on SignDocumentMutationFailed {
          errorType
        }
      }
    }
  }
`

type Config = Omit<UseMutationConfig<useDeSignReferralLetterWithTelematikInfrastructureMutationType>, "variables"> & {
  id: De_signReferralLetterDocumentWithTelematikInfrastructureInput["id"]
}

const useDeSignReferralLetterWithTelematikInfrastructureMutation = () => {
  const [commit, isFlight] = useMutationWithErrorDialog<useDeSignReferralLetterWithTelematikInfrastructureMutationType>(
    mutation,
    TELEMATIK_INFRASTRUCTURE_SIGNING_MUTATION_PARAMS,
  )

  const commitHandler = useCallback(
    async (config: Config) => {
      commit({
        variables: {
          input: {
            id: config.id,
          },
        },
        ...config,
      })
    },
    [commit],
  )

  return [commitHandler, isFlight] as const
}

export { useDeSignReferralLetterWithTelematikInfrastructureMutation }
